import * as React from "react"

const SvgComponent = (props) => (
    <div className="p-3 d-flex  justify-content-center">
        <div>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            scale={0.10}
            data-name="Layer 1"
            width={688.606}
            viewBox="120 0 700 560"
            height={405.465}
            {...props}
        >
            <path
                d="M736.637 503.621c-10.217-6.835-15.362-19.838-15.565-32.129-.068-4.121.973-8.9 4.665-10.733a6.41 6.41 0 0 1 9.174 6.785 62.045 62.045 0 0 1 5.3-11.516c1.825-3.088 4.388-6.302 7.963-6.596 4.148-.34 7.613 3.688 8.2 7.808s-.91 8.22-2.384 12.112a10.83 10.83 0 0 1 17.159-6.084c4.056 3.131 5.393 8.894 4.372 13.916s-4.017 9.415-7.33 13.323c-3.887 4.583-8.386 8.77-13.774 11.431s-11.758 3.678-17.489 1.874Z"
                fill="#f2f2f2"
            />
            <path
                d="M596.895 339.023a10.743 10.743 0 0 0 3.841-16.018l25.033-121.54-23.36-.308-17.384 119.998a10.8 10.8 0 0 0 11.87 17.868ZM710.68 332.712a10.743 10.743 0 0 0-.898-16.448L699.03 192.639l-22.474 6.382 17.641 119.96a10.8 10.8 0 0 0 16.482 13.73ZM638.591 492.157l-12.26-.001-5.832-47.288 18.094.001-.002 47.288z"
                fill="#ffb8b8"
            />
            <path
                d="M617.574 488.653h23.644v14.887h-38.53a14.887 14.887 0 0 1 14.886-14.887Z"
                fill="#2f2e41"
            />
            <path
                fill="#ffb8b8"
                d="m693.591 492.157-12.26-.001-5.832-47.288 18.094.001-.002 47.288z"
            />
            <path
                d="M672.574 488.653h23.644v14.887h-38.53a14.887 14.887 0 0 1 14.886-14.887Z"
                fill="#2f2e41"
            />
            <circle cx={641.768} cy={129.732} r={24.561} fill="#ffb8b8" />
            <path
                d="M676.296 462.32a4.334 4.334 0 0 1-4.231-3.49l-16.604-85.907a3.35 3.35 0 0 0-6.618.266l-9.297 83.678a4.285 4.285 0 0 1-4.085 3.825l-13.945.634a4.235 4.235 0 0 1-3.106-1.128 4.278 4.278 0 0 1-1.392-2.996l-5.347-129.259a4.28 4.28 0 0 1 1.508-3.454l3.092-2.638a4.311 4.311 0 0 1 2.794-1.03h72.28a4.311 4.311 0 0 1 4.306 4.307v132.23a4.299 4.299 0 0 1-4.12 4.302l-15.05.655c-.062.002-.124.004-.185.004Z"
                fill="#2f2e41"
            />
            <path
                d="M639.279 339.628c-11.686 0-21.987-3.114-27.187-12.195a4.387 4.387 0 0 1-.586-2.472l6.534-99.876a3.35 3.35 0 0 0-.679-2.25l-18.334-24.04a4.305 4.305 0 0 1 .824-6.042l27.502-20.836a3.366 3.366 0 0 0 1.198-1.75l.801-2.803a4.298 4.298 0 0 1 3.975-3.12l20.181-.777a4.348 4.348 0 0 1 3.529 1.614l2.147 2.684a3.341 3.341 0 0 0 .996.84l33.75 18.65a4.315 4.315 0 0 1 2.223 3.724v.06l-.013.057c-7.867 32.803-7.425 74.264 1.392 130.485a4.305 4.305 0 0 1-2.58 4.063c-7.305 3.164-33.892 13.984-55.673 13.984Z"
                fill="#6c63ff"
            />
            <path
                d="M618.727 236.604H595.87a4.3 4.3 0 0 1-4.3-4.55c.34-5.824 1.012-16.898 1.683-25.632.967-12.568 13.282-18.754 13.406-18.816l.24-.118 8.315 5.278 7.737 38.688a4.307 4.307 0 0 1-4.223 5.15ZM681.363 234.47a4.312 4.312 0 0 1-4.26-4.775l4.218-38.81 8.15-5.97.186.021c.087.01 8.77 1.094 12.659 10.818 2.77 6.924 7 19.721 9.275 26.733a4.302 4.302 0 0 1-3.08 5.507l-26.109 6.35a4.356 4.356 0 0 1-1.039.127Z"
                fill="#6c63ff"
            />
            <path
                d="M642.327 154.465c5.253-8.311-1.305-31.19-15.596-31.786-3.3-.138-4.566-4.94-5.687-8.045a12.39 12.39 0 0 1 1.61-10.78 20.337 20.337 0 0 1 8.676-7.007 30.107 30.107 0 1 1 16.86 57.157Z"
                fill="#2f2e41"
            />
            <path
                d="M494 0H7a7.008 7.008 0 0 0-7 7v330a7.008 7.008 0 0 0 7 7h487a7.008 7.008 0 0 0 7-7V7a7.008 7.008 0 0 0-7-7Zm5 337a5.002 5.002 0 0 1-5 5H7a5.002 5.002 0 0 1-5-5V7a5.002 5.002 0 0 1 5-5h487a5.002 5.002 0 0 1 5 5Z"
                fill="#3f3d56"
            />
            <path fill="#3f3d56" d="M1 28.04h499v2H1z" />
            <circle cx={18} cy={15} r={6} fill="#3f3d56" />
            <circle cx={35.25} cy={15} r={6} fill="#3f3d56" />
            <circle cx={52.5} cy={15} r={6} fill="#3f3d56" />
            <path
                d="M403.827 96.465h-310a15.5 15.5 0 0 1 0-31h310a15.5 15.5 0 0 1 0 31Zm-310-29a13.5 13.5 0 0 0 0 27h310a13.5 13.5 0 0 0 0-27ZM173.827 175.465h-60a15.5 15.5 0 0 1 0-31h60a15.5 15.5 0 0 1 0 31Zm-60-29a13.5 13.5 0 0 0 0 27h60a13.5 13.5 0 0 0 0-27ZM173.827 227.465h-60a15.5 15.5 0 0 1 0-31h60a15.5 15.5 0 0 1 0 31Zm-60-29a13.5 13.5 0 0 0 0 27h60a13.5 13.5 0 0 0 0-27ZM173.827 279.465h-60a15.5 15.5 0 0 1 0-31h60a15.5 15.5 0 0 1 0 31Zm-60-29a13.5 13.5 0 0 0 0 27h60a13.5 13.5 0 0 0 0-27Z"
                fill="#3f3d56"
            />
            <path
                d="M182.827 87.965h-84a7 7 0 0 1 0-14h84a7 7 0 0 1 0 14Z"
                fill="#6c63ff"
            />
            <path
                d="M393.327 84.465a7 7 0 1 1 7-7 7.008 7.008 0 0 1-7 7Zm0-12a5 5 0 1 0 5 5 5.006 5.006 0 0 0-5-5Z"
                fill="#3f3d56"
            />
            <path
                d="M404.155 90.797a.997.997 0 0 1-.707-.293l-7.026-7.026a1 1 0 1 1 1.414-1.414l7.026 7.026a1 1 0 0 1-.707 1.707Z"
                fill="#3f3d56"
            />
            <path
                d="M389.327 169.465h-34a9.5 9.5 0 0 1 0-19h34a9.5 9.5 0 0 1 0 19ZM389.327 221.465h-34a9.5 9.5 0 0 1 0-19h34a9.5 9.5 0 0 1 0 19ZM389.327 273.465h-34a9.5 9.5 0 0 1 0-19h34a9.5 9.5 0 0 1 0 19Z"
                fill="#6c63ff"
            />
            <path
                d="M787.606 505.465h-248a1 1 0 0 1 0-2h248a1 1 0 0 1 0 2Z"
                fill="#3f3d56"
            />
        </svg>
        <div className=" mt--8  pb-3">
            <h1>{props?.title}</h1>
            <p className="text-muted">{props?.subTitle}</p>
        </div>
        </div>
    </div>

)

export default SvgComponent
